import React, { useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const AddPaymentRequestTour = ({ forceStart, onTourEnd }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false);
    }

    const seenTour = localStorage.getItem('tour_seen_add_payment');

    if (!forceStart && seenTour) return;

    const timer = setTimeout(() => {
      setSteps([
        {
          target: '.tour-pay-amount',
          content: 'Enter the exact dollar amount you are requesting from the patient here.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-pay-purpose',
          content: 'Select the primary reason or service type this payment covers.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-pay-requester',
          content: 'Select the requester associated with this payment.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-pay-date',
          content: 'Confirm the date of this request.',
          placement: 'bottom',
          disableBeacon: true,
          disableScrolling: true
        },
        {
          target: '.tour-pay-submit',
          content: 'Click Submit to process the payment request.',
          placement: 'top',
          disableBeacon: true,
          disableScrolling: true
        }
      ]);
      
      setRun(true);
    }, 400); // Slight delay for the modal animation

    return () => clearTimeout(timer);
  }, [forceStart]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (onTourEnd) onTourEnd();
      localStorage.setItem('tour_seen_add_payment', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideCloseButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: { primaryColor: '#000000', textColor: '#000000', zIndex: 10000 },
        tooltip: { borderRadius: '8px', padding: '20px' },
        buttonNext: { backgroundColor: '#3c8138', borderRadius: '4px' },
        buttonBack: { color: '#3c8138' }
      }}
    />
  );
};

export default AddPaymentRequestTour;